export default __webpack_public_path__ + "static/media/fallbackImage.dee43ab6.svg";